module.exports = __webpack_public_path__ + "static/img/Jake-Turpin.731c1d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Turpin.jpg
// module id = P9S8
// module chunks = 0